var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F642(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 20.5,
    cy: 26.592,
    r: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#664E27",
    cx: 43.5,
    cy: 26.592,
    r: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M44.584 40.279c-8.11 5.656-17.107 5.623-25.168 0-.971-.677-1.846.495-1.188 1.578 2.457 4.047 7.418 7.65 13.771 7.65s11.313-3.604 13.771-7.65c.659-1.083-.216-2.254-1.186-1.578z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F642);
export default __webpack_public_path__ + "static/media/1f642.db78afedb7bd58d025787106c2a47404.svg";
export { ForwardRef as ReactComponent };